import { FC } from 'react';
import { Typography } from '@mui/material';

import { DspGeoLocation } from '../../../../../types/DspGeoLocation';

interface CampaignAdGroupLocationTargetingSummaryTextProps {
    dspLocations: DspGeoLocation[];
    dspGeoLocations: DspGeoLocation[];
}

const CampaignAdGroupLocationTargetingSummaryText: FC<CampaignAdGroupLocationTargetingSummaryTextProps> = ({
    dspLocations,
    dspGeoLocations,
}) => {
    const dspLocationCount: number = dspLocations.length;
    const dspGeoLocationCount: number = dspGeoLocations.length;

    return (
        <Typography variant="subtitle2">
            <Typography component="span" variant="subtitle2" color="text.primary">
                {dspLocationCount}
            </Typography>{' '}
            Locations and{' '}
            <Typography component="span" variant="subtitle2" color="text.primary">
                {dspGeoLocationCount}
            </Typography>{' '}
            Zip Codes
        </Typography>
    );
};

export default CampaignAdGroupLocationTargetingSummaryText;
